'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('../../tslib.es6-fe93d37b.js');
require('../../inheritsLoose-0fedacb9.js');
require('../../hqo-theme-79db6cc8.js');
require('../../constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('../../svg-icon-501cae97.js');
require('../../caret-down-00294a07.js');
var close = require('../../close-40bc5458.js');
require('../../close-filled-e2468f78.js');
require('../../exclamation-mark-02f43bf2.js');
require('../../cancel-2161b174.js');
require('../../hexToRgb-7c8edffc.js');
require('../../pill-89b3b361.js');
require('../../form-field-8601b6d9.js');
require('../../enums-de2d9d36.js');
require('../../asterisk-436ee6b3.js');
require('../../field-label-4ed9b7f8.js');
require('../../_commonjsHelpers-1b94f6bc.js');
require('../../index-c3c373ce.js');
require('../../field-hint-cc714695.js');
require('../../messages-f8f39369.js');
require('../../input-20e62297.js');
require('../../loader-8f6b1e8c.js');
require('@material-ui/core/InputBase');
require('@material-ui/core/Select');
require('../../select-6c9d108c.js');
require('../../select-item-7fd13c43.js');
require('../../select-title-65885e9f.js');
require('../../styles-a9f2fe66.js');
var button = require('../../button-c50f4784.js');
require('../../calendar-date.styles-9072cd1e.js');
require('../../styles-20009c57.js');
require('../../index-d4dda1ce.js');
require('../../index-6aab2a08.js');
require('../../index.es-1f72f6f2.js');
require('../../index.esm-c41adfff.js');
require('../../index-c25ba35c.js');
require('../../fa-icon-d6ca067a.js');
require('../../field.styles-a36bbd7b.js');
require('../../styles-424066e0.js');
require('../../overlay-878554b6.js');
require('../../paper-e6cfe656.js');
require('../../style-0cb3d1f5.js');
require('../../styles-558f9987.js');
require('../../native-select.styles-3602a739.js');
require('../../select-wrapper.styles-0104a777.js');
require('../../device.context-f96381a3.js');
require('../../mobile-detect-2421ba00.js');
require('../../styles-38df6401.js');
require('../../styles-f287cb5d.js');
require('../../status-indicator-57cc71fd.js');
require('../../styles-6fa8f6cf.js');
require('../../text-break-b3fca248.js');
require('../../tooltip-8d9d80ea.js');

var ToastContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  height: 47px;\n  border-radius: 8px;\n  background: ", ";\n  opacity: 0.8;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 8px;\n"], ["\n  width: 100%;\n  height: 47px;\n  border-radius: 8px;\n  background: ", ";\n  opacity: 0.8;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
});
var ToastBody = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px\n"])));
var ToastText = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/22px ", ";\n  color: ", ";\n"], ["\n  font: 400 14px/22px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$white;
});
var templateObject_1, templateObject_2, templateObject_3;

var ToastMessage = function (_a) {
    var text = _a.text, icon = _a.icon, onClose = _a.onClose, className = _a.className;
    return (React__default.createElement(ToastContainer, { className: className },
        React__default.createElement(ToastBody, null,
            icon,
            React__default.createElement(ToastText, null, text)),
        React__default.createElement(button.Button, { variant: "closeButton", size: "sm", Icon: (React__default.createElement(close.Close, { variant: "white", size: "xs" })), onClick: onClose, dataCy: "close-button" })));
};

exports.ToastMessage = ToastMessage;
